import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { map } from "lodash-es";
import { Typography, TypographyVariant, Image } from "@onmo/ui";
import { useStyles } from "./GamesCategory.style";
import { Game, getUserB2bSubscriptionGQL } from "@onmo/graphql/graphql";
import { PageRoutes } from "../../../constants/routes";
import { useLocation, useNavigate } from "react-router-dom";
import Gems from "../../../assets/leaderboard/gems.webp";
import Gems2x from "../../../assets/leaderboard/gems@2x.webp";
import Gems3x from "../../../assets/leaderboard/gems@3x.webp";
import { useAppSelector } from "../../../hooks";
import { UserSubscriptionStatus, User } from "@onmo/graphql/graphql";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { GameCard } from "../GameCard/GameCard";

interface IGamesCategoryProps {
  title: string;
  games: Game[];
}

export const GamesCategory: FC<
  IGamesCategoryProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { title, games, className, ...otherProps } = props;
  const { theme } = useAppSelector((state) => state.theme);
  const { data: dataSubscription } = useQuery<{ me: User }>(
    getUserB2bSubscriptionGQL,
  );
  const isGuestPage = location.pathname === PageRoutes.Guest;

  const onPlayGame = (gameId: string) => {
    const subscription = dataSubscription?.me?.subscription;
    if (theme?.requireSubscriptionToPlay && !subscription) return;
    if (
      theme?.requireSubscriptionToPlay &&
      subscription?.status === UserSubscriptionStatus.NotSubscribed
    ) {
      window.open(subscription?.redirectUrl, "_self");
      return;
    }
    !isGuestPage && navigate(`${PageRoutes.Play}/${gameId}`);
  };

  if (!games?.length) return null;

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <Typography
        variant={TypographyVariant.HeadingH6Bold}
        className={classes.headerTitle}
      >
        {t(`category.${title}`)}
      </Typography>
      <div className={classes.content}>
        {map(games, (game, idx) => {

          return (
            <GameCard
              game={game}
              key={idx}
              id={game.id}
              gemsSlot={
                <div className={classes.gems}>
                  <Image
                    src={Gems}
                    src2x={Gems2x}
                    src3x={Gems3x}
                    className={classes.gemImg}
                  />
                </div>
              }
              onClick={() => onPlayGame(game.id)}
            />
          );
        })}
      </div>
    </div>
  );
};
